(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6139],{

/***/ 44363:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$({ target: 'Number', stat: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});


/***/ }),

/***/ 9924:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-iterator-helpers
var $ = __webpack_require__(82109);
var aFunction = __webpack_require__(13099);
var anObject = __webpack_require__(19670);
var createIteratorProxy = __webpack_require__(54956);
var callWithSafeIterationClosing = __webpack_require__(53411);

var IteratorProxy = createIteratorProxy(function (args) {
  var iterator = this.iterator;
  var result = anObject(this.next.apply(iterator, args));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, result.value);
});

$({ target: 'Iterator', proto: true, real: true }, {
  map: function map(mapper) {
    return new IteratorProxy({
      iterator: anObject(this),
      mapper: aFunction(mapper)
    });
  }
});


/***/ }),

/***/ 76139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AddressInput_AddressInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(68304);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(88674);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(32023);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(2490);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(59849);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(34514);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/Search.js
var Search = __webpack_require__(86048);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Box/Box.mjs
var Box = __webpack_require__(8013);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/addressValidation.mjs
var addressValidation = __webpack_require__(63353);
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/googleMaps.mjs
var googleMaps = __webpack_require__(99835);
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/core/AutocompleteInput/index.mjs + 1 modules
var AutocompleteInput = __webpack_require__(59801);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/core/AddressInput/AddressInput.mjs

function cov_syhivb711() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/core/AddressInput/AddressInput.tsx";
    var hash = "820f0fa71c9c293578c5567d64036e4d74c61de6";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/core/AddressInput/AddressInput.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 19,
                    column: 32
                },
                end: {
                    line: 19,
                    column: 35
                }
            },
            "1": {
                start: {
                    line: 103,
                    column: 50
                },
                end: {
                    line: 361,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 132,
                    column: 40
                },
                end: {
                    line: 132,
                    column: 78
                }
            },
            "3": {
                start: {
                    line: 133,
                    column: 46
                },
                end: {
                    line: 133,
                    column: 91
                }
            },
            "4": {
                start: {
                    line: 134,
                    column: 54
                },
                end: {
                    line: 134,
                    column: 82
                }
            },
            "5": {
                start: {
                    line: 135,
                    column: 36
                },
                end: {
                    line: 135,
                    column: 51
                }
            },
            "6": {
                start: {
                    line: 136,
                    column: 25
                },
                end: {
                    line: 136,
                    column: 73
                }
            },
            "7": {
                start: {
                    line: 136,
                    column: 40
                },
                end: {
                    line: 136,
                    column: 72
                }
            },
            "8": {
                start: {
                    line: 137,
                    column: 19
                },
                end: {
                    line: 137,
                    column: 49
                }
            },
            "9": {
                start: {
                    line: 138,
                    column: 22
                },
                end: {
                    line: 138,
                    column: 35
                }
            },
            "10": {
                start: {
                    line: 141,
                    column: 23
                },
                end: {
                    line: 141,
                    column: 42
                }
            },
            "11": {
                start: {
                    line: 142,
                    column: 21
                },
                end: {
                    line: 142,
                    column: 62
                }
            },
            "12": {
                start: {
                    line: 144,
                    column: 27
                },
                end: {
                    line: 149,
                    column: 3
                }
            },
            "13": {
                start: {
                    line: 145,
                    column: 4
                },
                end: {
                    line: 147,
                    column: 5
                }
            },
            "14": {
                start: {
                    line: 146,
                    column: 6
                },
                end: {
                    line: 146,
                    column: 38
                }
            },
            "15": {
                start: {
                    line: 148,
                    column: 4
                },
                end: {
                    line: 148,
                    column: 25
                }
            },
            "16": {
                start: {
                    line: 151,
                    column: 2
                },
                end: {
                    line: 153,
                    column: 41
                }
            },
            "17": {
                start: {
                    line: 152,
                    column: 4
                },
                end: {
                    line: 152,
                    column: 39
                }
            },
            "18": {
                start: {
                    line: 157,
                    column: 2
                },
                end: {
                    line: 161,
                    column: 53
                }
            },
            "19": {
                start: {
                    line: 158,
                    column: 4
                },
                end: {
                    line: 160,
                    column: 5
                }
            },
            "20": {
                start: {
                    line: 159,
                    column: 6
                },
                end: {
                    line: 159,
                    column: 39
                }
            },
            "21": {
                start: {
                    line: 163,
                    column: 27
                },
                end: {
                    line: 166,
                    column: 3
                }
            },
            "22": {
                start: {
                    line: 164,
                    column: 4
                },
                end: {
                    line: 164,
                    column: 28
                }
            },
            "23": {
                start: {
                    line: 165,
                    column: 4
                },
                end: {
                    line: 165,
                    column: 23
                }
            },
            "24": {
                start: {
                    line: 168,
                    column: 35
                },
                end: {
                    line: 210,
                    column: 3
                }
            },
            "25": {
                start: {
                    line: 170,
                    column: 6
                },
                end: {
                    line: 208,
                    column: 33
                }
            },
            "26": {
                start: {
                    line: 171,
                    column: 8
                },
                end: {
                    line: 174,
                    column: 9
                }
            },
            "27": {
                start: {
                    line: 172,
                    column: 10
                },
                end: {
                    line: 172,
                    column: 29
                }
            },
            "28": {
                start: {
                    line: 173,
                    column: 10
                },
                end: {
                    line: 173,
                    column: 17
                }
            },
            "29": {
                start: {
                    line: 176,
                    column: 8
                },
                end: {
                    line: 207,
                    column: 9
                }
            },
            "30": {
                start: {
                    line: 177,
                    column: 27
                },
                end: {
                    line: 177,
                    column: 81
                }
            },
            "31": {
                start: {
                    line: 178,
                    column: 23
                },
                end: {
                    line: 178,
                    column: 44
                }
            },
            "32": {
                start: {
                    line: 181,
                    column: 10
                },
                end: {
                    line: 185,
                    column: 13
                }
            },
            "33": {
                start: {
                    line: 182,
                    column: 12
                },
                end: {
                    line: 182,
                    column: 73
                }
            },
            "34": {
                start: {
                    line: 183,
                    column: 12
                },
                end: {
                    line: 183,
                    column: 85
                }
            },
            "35": {
                start: {
                    line: 184,
                    column: 12
                },
                end: {
                    line: 184,
                    column: 50
                }
            },
            "36": {
                start: {
                    line: 188,
                    column: 27
                },
                end: {
                    line: 201,
                    column: 12
                }
            },
            "37": {
                start: {
                    line: 189,
                    column: 12
                },
                end: {
                    line: 189,
                    column: 40
                }
            },
            "38": {
                start: {
                    line: 190,
                    column: 12
                },
                end: {
                    line: 199,
                    column: 13
                }
            },
            "39": {
                start: {
                    line: 191,
                    column: 28
                },
                end: {
                    line: 191,
                    column: 46
                }
            },
            "40": {
                start: {
                    line: 192,
                    column: 35
                },
                end: {
                    line: 194,
                    column: 15
                }
            },
            "41": {
                start: {
                    line: 193,
                    column: 16
                },
                end: {
                    line: 193,
                    column: 44
                }
            },
            "42": {
                start: {
                    line: 195,
                    column: 14
                },
                end: {
                    line: 198,
                    column: 16
                }
            },
            "43": {
                start: {
                    line: 200,
                    column: 12
                },
                end: {
                    line: 200,
                    column: 24
                }
            },
            "44": {
                start: {
                    line: 203,
                    column: 10
                },
                end: {
                    line: 203,
                    column: 35
                }
            },
            "45": {
                start: {
                    line: 205,
                    column: 10
                },
                end: {
                    line: 205,
                    column: 29
                }
            },
            "46": {
                start: {
                    line: 206,
                    column: 10
                },
                end: {
                    line: 206,
                    column: 36
                }
            },
            "47": {
                start: {
                    line: 213,
                    column: 2
                },
                end: {
                    line: 230,
                    column: 67
                }
            },
            "48": {
                start: {
                    line: 214,
                    column: 4
                },
                end: {
                    line: 214,
                    column: 38
                }
            },
            "49": {
                start: {
                    line: 214,
                    column: 31
                },
                end: {
                    line: 214,
                    column: 38
                }
            },
            "50": {
                start: {
                    line: 217,
                    column: 4
                },
                end: {
                    line: 220,
                    column: 5
                }
            },
            "51": {
                start: {
                    line: 218,
                    column: 6
                },
                end: {
                    line: 218,
                    column: 33
                }
            },
            "52": {
                start: {
                    line: 219,
                    column: 6
                },
                end: {
                    line: 219,
                    column: 13
                }
            },
            "53": {
                start: {
                    line: 223,
                    column: 4
                },
                end: {
                    line: 227,
                    column: 5
                }
            },
            "54": {
                start: {
                    line: 224,
                    column: 6
                },
                end: {
                    line: 224,
                    column: 25
                }
            },
            "55": {
                start: {
                    line: 226,
                    column: 6
                },
                end: {
                    line: 226,
                    column: 43
                }
            },
            "56": {
                start: {
                    line: 232,
                    column: 28
                },
                end: {
                    line: 239,
                    column: 3
                }
            },
            "57": {
                start: {
                    line: 233,
                    column: 21
                },
                end: {
                    line: 233,
                    column: 35
                }
            },
            "58": {
                start: {
                    line: 234,
                    column: 4
                },
                end: {
                    line: 234,
                    column: 31
                }
            },
            "59": {
                start: {
                    line: 235,
                    column: 4
                },
                end: {
                    line: 235,
                    column: 39
                }
            },
            "60": {
                start: {
                    line: 236,
                    column: 4
                },
                end: {
                    line: 238,
                    column: 5
                }
            },
            "61": {
                start: {
                    line: 237,
                    column: 6
                },
                end: {
                    line: 237,
                    column: 25
                }
            },
            "62": {
                start: {
                    line: 241,
                    column: 33
                },
                end: {
                    line: 283,
                    column: 3
                }
            },
            "63": {
                start: {
                    line: 243,
                    column: 4
                },
                end: {
                    line: 243,
                    column: 29
                }
            },
            "64": {
                start: {
                    line: 245,
                    column: 4
                },
                end: {
                    line: 245,
                    column: 34
                }
            },
            "65": {
                start: {
                    line: 246,
                    column: 4
                },
                end: {
                    line: 246,
                    column: 45
                }
            },
            "66": {
                start: {
                    line: 247,
                    column: 4
                },
                end: {
                    line: 247,
                    column: 23
                }
            },
            "67": {
                start: {
                    line: 248,
                    column: 4
                },
                end: {
                    line: 248,
                    column: 23
                }
            },
            "68": {
                start: {
                    line: 251,
                    column: 6
                },
                end: {
                    line: 261,
                    column: 12
                }
            },
            "69": {
                start: {
                    line: 263,
                    column: 4
                },
                end: {
                    line: 282,
                    column: 5
                }
            },
            "70": {
                start: {
                    line: 264,
                    column: 23
                },
                end: {
                    line: 264,
                    column: 39
                }
            },
            "71": {
                start: {
                    line: 265,
                    column: 39
                },
                end: {
                    line: 265,
                    column: 60
                }
            },
            "72": {
                start: {
                    line: 268,
                    column: 6
                },
                end: {
                    line: 275,
                    column: 7
                }
            },
            "73": {
                start: {
                    line: 269,
                    column: 8
                },
                end: {
                    line: 274,
                    column: 9
                }
            },
            "74": {
                start: {
                    line: 270,
                    column: 35
                },
                end: {
                    line: 270,
                    column: 71
                }
            },
            "75": {
                start: {
                    line: 271,
                    column: 10
                },
                end: {
                    line: 271,
                    column: 47
                }
            },
            "76": {
                start: {
                    line: 273,
                    column: 10
                },
                end: {
                    line: 273,
                    column: 46
                }
            },
            "77": {
                start: {
                    line: 277,
                    column: 6
                },
                end: {
                    line: 277,
                    column: 31
                }
            },
            "78": {
                start: {
                    line: 279,
                    column: 6
                },
                end: {
                    line: 279,
                    column: 32
                }
            },
            "79": {
                start: {
                    line: 281,
                    column: 6
                },
                end: {
                    line: 281,
                    column: 26
                }
            },
            "80": {
                start: {
                    line: 285,
                    column: 21
                },
                end: {
                    line: 309,
                    column: 3
                }
            },
            "81": {
                start: {
                    line: 287,
                    column: 26
                },
                end: {
                    line: 292,
                    column: 14
                }
            },
            "82": {
                start: {
                    line: 293,
                    column: 23
                },
                end: {
                    line: 293,
                    column: 65
                }
            },
            "83": {
                start: {
                    line: 295,
                    column: 4
                },
                end: {
                    line: 308,
                    column: 6
                }
            },
            "84": {
                start: {
                    line: 312,
                    column: 4
                },
                end: {
                    line: 319,
                    column: 6
                }
            },
            "85": {
                start: {
                    line: 321,
                    column: 35
                },
                end: {
                    line: 321,
                    column: 46
                }
            },
            "86": {
                start: {
                    line: 322,
                    column: 2
                },
                end: {
                    line: 332,
                    column: 3
                }
            },
            "87": {
                start: {
                    line: 323,
                    column: 20
                },
                end: {
                    line: 329,
                    column: 5
                }
            },
            "88": {
                start: {
                    line: 324,
                    column: 6
                },
                end: {
                    line: 328,
                    column: 7
                }
            },
            "89": {
                start: {
                    line: 325,
                    column: 8
                },
                end: {
                    line: 325,
                    column: 47
                }
            },
            "90": {
                start: {
                    line: 326,
                    column: 13
                },
                end: {
                    line: 328,
                    column: 7
                }
            },
            "91": {
                start: {
                    line: 327,
                    column: 8
                },
                end: {
                    line: 327,
                    column: 47
                }
            },
            "92": {
                start: {
                    line: 330,
                    column: 27
                },
                end: {
                    line: 330,
                    column: 59
                }
            },
            "93": {
                start: {
                    line: 331,
                    column: 4
                },
                end: {
                    line: 331,
                    column: 31
                }
            },
            "94": {
                start: {
                    line: 334,
                    column: 2
                },
                end: {
                    line: 360,
                    column: 4
                }
            },
            "95": {
                start: {
                    line: 349,
                    column: 22
                },
                end: {
                    line: 349,
                    column: 40
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 103,
                        column: 50
                    },
                    end: {
                        line: 103,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 131,
                        column: 6
                    },
                    end: {
                        line: 361,
                        column: 1
                    }
                },
                line: 131
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 136,
                        column: 34
                    },
                    end: {
                        line: 136,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 136,
                        column: 40
                    },
                    end: {
                        line: 136,
                        column: 72
                    }
                },
                line: 136
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 144,
                        column: 27
                    },
                    end: {
                        line: 144,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 144,
                        column: 49
                    },
                    end: {
                        line: 149,
                        column: 3
                    }
                },
                line: 144
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 151,
                        column: 12
                    },
                    end: {
                        line: 151,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 151,
                        column: 18
                    },
                    end: {
                        line: 153,
                        column: 3
                    }
                },
                line: 151
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 157,
                        column: 12
                    },
                    end: {
                        line: 157,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 157,
                        column: 18
                    },
                    end: {
                        line: 161,
                        column: 3
                    }
                },
                line: 157
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 163,
                        column: 27
                    },
                    end: {
                        line: 163,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 163,
                        column: 33
                    },
                    end: {
                        line: 166,
                        column: 3
                    }
                },
                line: 163
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 169,
                        column: 4
                    },
                    end: {
                        line: 169,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 170,
                        column: 6
                    },
                    end: {
                        line: 208,
                        column: 33
                    }
                },
                line: 170
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 170,
                        column: 15
                    },
                    end: {
                        line: 170,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 170,
                        column: 40
                    },
                    end: {
                        line: 208,
                        column: 7
                    }
                },
                line: 170
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 181,
                        column: 35
                    },
                    end: {
                        line: 181,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 181,
                        column: 71
                    },
                    end: {
                        line: 185,
                        column: 11
                    }
                },
                line: 181
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 188,
                        column: 51
                    },
                    end: {
                        line: 188,
                        column: 52
                    }
                },
                loc: {
                    start: {
                        line: 188,
                        column: 87
                    },
                    end: {
                        line: 201,
                        column: 11
                    }
                },
                line: 188
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 192,
                        column: 63
                    },
                    end: {
                        line: 192,
                        column: 64
                    }
                },
                loc: {
                    start: {
                        line: 193,
                        column: 16
                    },
                    end: {
                        line: 193,
                        column: 44
                    }
                },
                line: 193
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 213,
                        column: 12
                    },
                    end: {
                        line: 213,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 213,
                        column: 18
                    },
                    end: {
                        line: 230,
                        column: 3
                    }
                },
                line: 213
            },
            "12": {
                name: "(anonymous_12)",
                decl: {
                    start: {
                        line: 232,
                        column: 28
                    },
                    end: {
                        line: 232,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 232,
                        column: 72
                    },
                    end: {
                        line: 239,
                        column: 3
                    }
                },
                line: 232
            },
            "13": {
                name: "(anonymous_13)",
                decl: {
                    start: {
                        line: 241,
                        column: 33
                    },
                    end: {
                        line: 241,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 241,
                        column: 79
                    },
                    end: {
                        line: 283,
                        column: 3
                    }
                },
                line: 241
            },
            "14": {
                name: "(anonymous_14)",
                decl: {
                    start: {
                        line: 285,
                        column: 21
                    },
                    end: {
                        line: 285,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 285,
                        column: 61
                    },
                    end: {
                        line: 309,
                        column: 3
                    }
                },
                line: 285
            },
            "15": {
                name: "(anonymous_15)",
                decl: {
                    start: {
                        line: 323,
                        column: 20
                    },
                    end: {
                        line: 323,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 323,
                        column: 26
                    },
                    end: {
                        line: 329,
                        column: 5
                    }
                },
                line: 323
            },
            "16": {
                name: "(anonymous_16)",
                decl: {
                    start: {
                        line: 349,
                        column: 16
                    },
                    end: {
                        line: 349,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 349,
                        column: 22
                    },
                    end: {
                        line: 349,
                        column: 40
                    }
                },
                line: 349
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 112,
                        column: 2
                    },
                    end: {
                        line: 112,
                        column: 30
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 112,
                            column: 25
                        },
                        end: {
                            line: 112,
                            column: 30
                        }
                    }
                ],
                line: 112
            },
            "1": {
                loc: {
                    start: {
                        line: 115,
                        column: 2
                    },
                    end: {
                        line: 115,
                        column: 25
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 115,
                            column: 20
                        },
                        end: {
                            line: 115,
                            column: 25
                        }
                    }
                ],
                line: 115
            },
            "2": {
                loc: {
                    start: {
                        line: 134,
                        column: 63
                    },
                    end: {
                        line: 134,
                        column: 81
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 134,
                            column: 63
                        },
                        end: {
                            line: 134,
                            column: 75
                        }
                    },
                    {
                        start: {
                            line: 134,
                            column: 79
                        },
                        end: {
                            line: 134,
                            column: 81
                        }
                    }
                ],
                line: 134
            },
            "3": {
                loc: {
                    start: {
                        line: 142,
                        column: 21
                    },
                    end: {
                        line: 142,
                        column: 62
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 142,
                            column: 36
                        },
                        end: {
                            line: 142,
                            column: 41
                        }
                    },
                    {
                        start: {
                            line: 142,
                            column: 44
                        },
                        end: {
                            line: 142,
                            column: 62
                        }
                    }
                ],
                line: 142
            },
            "4": {
                loc: {
                    start: {
                        line: 145,
                        column: 4
                    },
                    end: {
                        line: 147,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 145,
                            column: 4
                        },
                        end: {
                            line: 147,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 145
            },
            "5": {
                loc: {
                    start: {
                        line: 158,
                        column: 4
                    },
                    end: {
                        line: 160,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 158,
                            column: 4
                        },
                        end: {
                            line: 160,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 158
            },
            "6": {
                loc: {
                    start: {
                        line: 171,
                        column: 8
                    },
                    end: {
                        line: 174,
                        column: 9
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 171,
                            column: 8
                        },
                        end: {
                            line: 174,
                            column: 9
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 171
            },
            "7": {
                loc: {
                    start: {
                        line: 183,
                        column: 24
                    },
                    end: {
                        line: 183,
                        column: 84
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 183,
                            column: 24
                        },
                        end: {
                            line: 183,
                            column: 39
                        }
                    },
                    {
                        start: {
                            line: 183,
                            column: 43
                        },
                        end: {
                            line: 183,
                            column: 62
                        }
                    },
                    {
                        start: {
                            line: 183,
                            column: 66
                        },
                        end: {
                            line: 183,
                            column: 84
                        }
                    }
                ],
                line: 183
            },
            "8": {
                loc: {
                    start: {
                        line: 190,
                        column: 12
                    },
                    end: {
                        line: 199,
                        column: 13
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 190,
                            column: 12
                        },
                        end: {
                            line: 199,
                            column: 13
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 190
            },
            "9": {
                loc: {
                    start: {
                        line: 191,
                        column: 28
                    },
                    end: {
                        line: 191,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 191,
                            column: 28
                        },
                        end: {
                            line: 191,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 191,
                            column: 44
                        },
                        end: {
                            line: 191,
                            column: 46
                        }
                    }
                ],
                line: 191
            },
            "10": {
                loc: {
                    start: {
                        line: 192,
                        column: 36
                    },
                    end: {
                        line: 192,
                        column: 54
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 192,
                            column: 36
                        },
                        end: {
                            line: 192,
                            column: 48
                        }
                    },
                    {
                        start: {
                            line: 192,
                            column: 52
                        },
                        end: {
                            line: 192,
                            column: 54
                        }
                    }
                ],
                line: 192
            },
            "11": {
                loc: {
                    start: {
                        line: 196,
                        column: 16
                    },
                    end: {
                        line: 197,
                        column: 87
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 196,
                            column: 17
                        },
                        end: {
                            line: 196,
                            column: 34
                        }
                    },
                    {
                        start: {
                            line: 196,
                            column: 38
                        },
                        end: {
                            line: 196,
                            column: 61
                        }
                    },
                    {
                        start: {
                            line: 197,
                            column: 17
                        },
                        end: {
                            line: 197,
                            column: 35
                        }
                    },
                    {
                        start: {
                            line: 197,
                            column: 39
                        },
                        end: {
                            line: 197,
                            column: 86
                        }
                    }
                ],
                line: 196
            },
            "12": {
                loc: {
                    start: {
                        line: 214,
                        column: 4
                    },
                    end: {
                        line: 214,
                        column: 38
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 214,
                            column: 4
                        },
                        end: {
                            line: 214,
                            column: 38
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 214
            },
            "13": {
                loc: {
                    start: {
                        line: 217,
                        column: 4
                    },
                    end: {
                        line: 220,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 217,
                            column: 4
                        },
                        end: {
                            line: 220,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 217
            },
            "14": {
                loc: {
                    start: {
                        line: 223,
                        column: 4
                    },
                    end: {
                        line: 227,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 223,
                            column: 4
                        },
                        end: {
                            line: 227,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 225,
                            column: 11
                        },
                        end: {
                            line: 227,
                            column: 5
                        }
                    }
                ],
                line: 223
            },
            "15": {
                loc: {
                    start: {
                        line: 236,
                        column: 4
                    },
                    end: {
                        line: 238,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 236,
                            column: 4
                        },
                        end: {
                            line: 238,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 236
            },
            "16": {
                loc: {
                    start: {
                        line: 251,
                        column: 6
                    },
                    end: {
                        line: 261,
                        column: 12
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 252,
                            column: 10
                        },
                        end: {
                            line: 256,
                            column: 12
                        }
                    },
                    {
                        start: {
                            line: 257,
                            column: 10
                        },
                        end: {
                            line: 261,
                            column: 12
                        }
                    }
                ],
                line: 251
            },
            "17": {
                loc: {
                    start: {
                        line: 268,
                        column: 6
                    },
                    end: {
                        line: 275,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 268,
                            column: 6
                        },
                        end: {
                            line: 275,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 268
            },
            "18": {
                loc: {
                    start: {
                        line: 268,
                        column: 10
                    },
                    end: {
                        line: 268,
                        column: 47
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 268,
                            column: 10
                        },
                        end: {
                            line: 268,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 268,
                            column: 29
                        },
                        end: {
                            line: 268,
                            column: 47
                        }
                    }
                ],
                line: 268
            },
            "19": {
                loc: {
                    start: {
                        line: 293,
                        column: 23
                    },
                    end: {
                        line: 293,
                        column: 65
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 293,
                            column: 30
                        },
                        end: {
                            line: 293,
                            column: 49
                        }
                    },
                    {
                        start: {
                            line: 293,
                            column: 52
                        },
                        end: {
                            line: 293,
                            column: 65
                        }
                    }
                ],
                line: 293
            },
            "20": {
                loc: {
                    start: {
                        line: 312,
                        column: 4
                    },
                    end: {
                        line: 319,
                        column: 6
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 312,
                            column: 4
                        },
                        end: {
                            line: 312,
                            column: 8
                        }
                    },
                    {
                        start: {
                            line: 313,
                            column: 5
                        },
                        end: {
                            line: 319,
                            column: 5
                        }
                    }
                ],
                line: 312
            },
            "21": {
                loc: {
                    start: {
                        line: 313,
                        column: 5
                    },
                    end: {
                        line: 319,
                        column: 5
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 314,
                            column: 6
                        },
                        end: {
                            line: 316,
                            column: 12
                        }
                    },
                    {
                        start: {
                            line: 318,
                            column: 6
                        },
                        end: {
                            line: 318,
                            column: 22
                        }
                    }
                ],
                line: 313
            },
            "22": {
                loc: {
                    start: {
                        line: 322,
                        column: 2
                    },
                    end: {
                        line: 332,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 322,
                            column: 2
                        },
                        end: {
                            line: 332,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 322
            },
            "23": {
                loc: {
                    start: {
                        line: 324,
                        column: 6
                    },
                    end: {
                        line: 328,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 324,
                            column: 6
                        },
                        end: {
                            line: 328,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: 326,
                            column: 13
                        },
                        end: {
                            line: 328,
                            column: 7
                        }
                    }
                ],
                line: 324
            },
            "24": {
                loc: {
                    start: {
                        line: 324,
                        column: 10
                    },
                    end: {
                        line: 324,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 324,
                            column: 10
                        },
                        end: {
                            line: 324,
                            column: 28
                        }
                    },
                    {
                        start: {
                            line: 324,
                            column: 32
                        },
                        end: {
                            line: 324,
                            column: 46
                        }
                    }
                ],
                line: 324
            },
            "25": {
                loc: {
                    start: {
                        line: 326,
                        column: 13
                    },
                    end: {
                        line: 328,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 326,
                            column: 13
                        },
                        end: {
                            line: 328,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 326
            },
            "26": {
                loc: {
                    start: {
                        line: 326,
                        column: 17
                    },
                    end: {
                        line: 326,
                        column: 76
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 326,
                            column: 17
                        },
                        end: {
                            line: 326,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 326,
                            column: 35
                        },
                        end: {
                            line: 326,
                            column: 76
                        }
                    }
                ],
                line: 326
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0,
            "54": 0,
            "55": 0,
            "56": 0,
            "57": 0,
            "58": 0,
            "59": 0,
            "60": 0,
            "61": 0,
            "62": 0,
            "63": 0,
            "64": 0,
            "65": 0,
            "66": 0,
            "67": 0,
            "68": 0,
            "69": 0,
            "70": 0,
            "71": 0,
            "72": 0,
            "73": 0,
            "74": 0,
            "75": 0,
            "76": 0,
            "77": 0,
            "78": 0,
            "79": 0,
            "80": 0,
            "81": 0,
            "82": 0,
            "83": 0,
            "84": 0,
            "85": 0,
            "86": 0,
            "87": 0,
            "88": 0,
            "89": 0,
            "90": 0,
            "91": 0,
            "92": 0,
            "93": 0,
            "94": 0,
            "95": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ],
            "10": [
                0,
                0
            ],
            "11": [
                0,
                0,
                0,
                0
            ],
            "12": [
                0,
                0
            ],
            "13": [
                0,
                0
            ],
            "14": [
                0,
                0
            ],
            "15": [
                0,
                0
            ],
            "16": [
                0,
                0
            ],
            "17": [
                0,
                0
            ],
            "18": [
                0,
                0
            ],
            "19": [
                0,
                0
            ],
            "20": [
                0,
                0
            ],
            "21": [
                0,
                0
            ],
            "22": [
                0,
                0
            ],
            "23": [
                0,
                0
            ],
            "24": [
                0,
                0
            ],
            "25": [
                0,
                0
            ],
            "26": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "820f0fa71c9c293578c5567d64036e4d74c61de6"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_syhivb711 = function cov_syhivb711() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_syhivb711();
function _regenerator() {
    var i = function i(r, n, o, i1) {
        var c = n && (0,_instanceof/* default */.Z)(n.prototype, Generator) ? n : Generator, u = Object.create(c.prototype);
        return _regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var _$i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return _$i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !_$o && t < p.length; t++){
                    var _$o, _$i = p[t], _$d = G.p, l = _$i[2];
                    r > 3 ? (_$o = l === n) && (u = _$i[(c = _$i[4]) ? 5 : (c = 3, 3)], _$i[4] = _$i[5] = e) : _$i[0] <= _$d && ((_$o = r < 2 && _$d < _$i[1]) ? (c = 0, G.v = n, G.n = _$i[1]) : _$d < l && (_$o = r < 3 || _$i[0] > n || n > l) && (_$i[4] = r, _$i[5] = n, G.n = l, c = 0));
                }
                if (_$o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    _$i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, _$i) {
                            if (c || (o = "next"), t = _$i[o]) {
                                if (!(t = t.call(_$i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = _$i["return"]) && t.call(_$i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            _$i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t1) {
                        _$i = e, c = 1, u = t1;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i1), !0), u;
    };
    var Generator = function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var f = function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    };
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    var a = {};
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function() {
        return this;
    }), _regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function _regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e1) {
        i = 0;
    }
    _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        var o = function o(r, n) {
            _regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        };
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine2(e, r, n, t);
}



























function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n1) {
        return void e(n1);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}







var DEBOUNCE_INVOKE_WAIT_MS = (cov_syhivb711().s[0]++, 100);
/**
 * @param actionButton overrides `icon` in the suffix position when provided
 */ cov_syhivb711().s[1]++;
var AddressInput = function AddressInput(_ref) {
    var _ref8, _ref15;
    var id = _ref.id, placeholder = _ref.placeholder, disabled = _ref.disabled, hideLabel = _ref.hideLabel, label = _ref.label, value = _ref.value, onChange = _ref.onChange, defaultValue = _ref.defaultValue, _ref$fetchOnExternalV = _ref.fetchOnExternalValue, fetchOnExternalValue = _ref$fetchOnExternalV === void 0 ? (cov_syhivb711().b[0][0]++, false) : _ref$fetchOnExternalV, onAddressSelect = _ref.onAddressSelect, onAddressValidated = _ref.onAddressValidated, _ref$validateAddress = _ref.validateAddress, validateAddress = _ref$validateAddress === void 0 ? (cov_syhivb711().b[1][0]++, false) : _ref$validateAddress, onError = _ref.onError, onPredictionsChange = _ref.onPredictionsChange, onSearchTermChange = _ref.onSearchTermChange, onFocus = _ref.onFocus, onBlur = _ref.onBlur, customAction = _ref.customAction, listBoxId = _ref.listBoxId, listBoxAriaLabel = _ref.listBoxAriaLabel, icon = _ref.icon, actionButton = _ref.actionButton, size = _ref.size, supportText = _ref.supportText, errorText = _ref.errorText, invalid = _ref.invalid, required = _ref.required;
    cov_syhivb711().f[0]++;
    var _ref2 = (cov_syhivb711().s[2]++, (0,react.useState)([])), _ref3 = _slicedToArray(_ref2, 2), predictions = _ref3[0], setPredictions = _ref3[1];
    var _ref4 = (cov_syhivb711().s[3]++, (0,react.useState)(null)), _ref5 = _slicedToArray(_ref4, 2), usedPrediction = _ref5[0], setUsedPrediction = _ref5[1];
    var _ref6 = (cov_syhivb711().s[4]++, (0,react.useState)((_ref8 = (cov_syhivb711().b[2][0]++, defaultValue)) !== null && _ref8 !== void 0 ? _ref8 : (cov_syhivb711().b[2][1]++, ""))), _ref7 = _slicedToArray(_ref6, 2), internalSearchTerm = _ref7[0], setInternalSearchTerm = _ref7[1];
    var _ref9 = (cov_syhivb711().s[5]++, (0,react.useState)(false)), _ref0 = _slicedToArray(_ref9, 2), isLoading = _ref0[0], setIsLoading = _ref0[1];
    var _ref1 = (cov_syhivb711().s[6]++, (0,react.useState)(function() {
        cov_syhivb711().f[1]++;
        cov_syhivb711().s[7]++;
        return (0,googleMaps/* generateGoogleMapsSessionToken */.h_)();
    })), _ref10 = _slicedToArray(_ref1, 1), sessionToken = _ref10[0];
    var inputRef = (cov_syhivb711().s[8]++, (0,react.useRef)(null));
    var didMountRef = (cov_syhivb711().s[9]++, (0,react.useRef)(false));
    // Determine if component is controlled (value prop is provided)
    var isControlled = (cov_syhivb711().s[10]++, value !== undefined);
    var searchTerm = (cov_syhivb711().s[11]++, isControlled ? (cov_syhivb711().b[3][0]++, value) : (cov_syhivb711().b[3][1]++, internalSearchTerm));
    cov_syhivb711().s[12]++;
    var updateSearchTerm = function updateSearchTerm(newValue) {
        cov_syhivb711().f[2]++;
        cov_syhivb711().s[13]++;
        if (!isControlled) {
            cov_syhivb711().b[4][0]++;
            cov_syhivb711().s[14]++;
            setInternalSearchTerm(newValue);
        } else {
            cov_syhivb711().b[4][1]++;
        }
        cov_syhivb711().s[15]++;
        onChange === null || onChange === void 0 || onChange(newValue);
    };
    cov_syhivb711().s[16]++;
    (0,react.useEffect)(function() {
        cov_syhivb711().f[3]++;
        cov_syhivb711().s[17]++;
        onPredictionsChange === null || onPredictionsChange === void 0 || onPredictionsChange(predictions);
    }, [
        predictions,
        onPredictionsChange
    ]);
    // For uncontrolled mode, notify on initial mount and when defaultValue changes
    // For controlled mode, the parent already knows the value
    cov_syhivb711().s[18]++;
    (0,react.useEffect)(function() {
        cov_syhivb711().f[4]++;
        cov_syhivb711().s[19]++;
        if (!isControlled) {
            cov_syhivb711().b[5][0]++;
            cov_syhivb711().s[20]++;
            onSearchTermChange === null || onSearchTermChange === void 0 || onSearchTermChange(searchTerm);
        } else {
            cov_syhivb711().b[5][1]++;
        }
    }, [
        isControlled,
        searchTerm,
        onSearchTermChange
    ]);
    cov_syhivb711().s[21]++;
    var clearPredictions = function clearPredictions() {
        cov_syhivb711().f[5]++;
        cov_syhivb711().s[22]++;
        setUsedPrediction(null);
        cov_syhivb711().s[23]++;
        setPredictions([]);
    };
    var fetchAutocompleteOptions = (cov_syhivb711().s[24]++, (0,react.useMemo)(function() {
        cov_syhivb711().f[6]++;
        cov_syhivb711().s[25]++;
        return debounce_default()(/*#__PURE__*/ function() {
            var _ref11 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(input) {
                var response, data, filtered, _t;
                return _regenerator().w(function(_context) {
                    while(1)switch(_context.p = _context.n){
                        case 0:
                            cov_syhivb711().f[7]++;
                            cov_syhivb711().s[26]++;
                            if (input) {
                                _context.n = 1;
                                break;
                            }
                            cov_syhivb711().b[6][0]++;
                            cov_syhivb711().s[27]++;
                            clearPredictions();
                            cov_syhivb711().s[28]++;
                            return _context.a(2);
                        case 1:
                            cov_syhivb711().b[6][1]++;
                        case 2:
                            cov_syhivb711().s[29]++;
                            _context.p = 3;
                            cov_syhivb711().s[30]++;
                            _context.n = 4;
                            return fetch((0,googleMaps/* buildAutocompleteUrl */.Iz)(input, sessionToken));
                        case 4:
                            response = _context.v;
                            cov_syhivb711().s[31]++;
                            _context.n = 5;
                            return response.json();
                        case 5:
                            data = _context.v;
                            cov_syhivb711().s[32]++;
                            // Clean descriptions by removing ', USA' and add required AutocompleteItem properties
                            data.predictions.forEach(function(result) {
                                cov_syhivb711().f[8]++;
                                cov_syhivb711().s[33]++;
                                result.description = result.description.replace(", USA", "");
                                cov_syhivb711().s[34]++;
                                result.id = (cov_syhivb711().b[7][0]++, result.place_id) || (cov_syhivb711().b[7][1]++, result.addressToken) || (cov_syhivb711().b[7][2]++, result.description);
                                cov_syhivb711().s[35]++;
                                result.ariaLabel = result.description;
                            });
                            // Filter predictions based on type and term count
                            filtered = (cov_syhivb711().s[36]++, data.predictions.filter(function(result) {
                                cov_syhivb711().f[9]++;
                                cov_syhivb711().s[37]++;
                                result.source = data.source;
                                cov_syhivb711().s[38]++;
                                if (data.source === "google") {
                                    var _ref12, _ref13;
                                    cov_syhivb711().b[8][0]++;
                                    var terms = (cov_syhivb711().s[39]++, (_ref12 = (cov_syhivb711().b[9][0]++, result.terms)) !== null && _ref12 !== void 0 ? _ref12 : (cov_syhivb711().b[9][1]++, []));
                                    var allowedTypes = (cov_syhivb711().s[40]++, ((_ref13 = (cov_syhivb711().b[10][0]++, result.types)) !== null && _ref13 !== void 0 ? _ref13 : (cov_syhivb711().b[10][1]++, [])).filter(function(type) {
                                        cov_syhivb711().f[10]++;
                                        cov_syhivb711().s[41]++;
                                        return googleMaps/* ALLOWED_TYPES.includes */.MF.includes(type);
                                    }));
                                    cov_syhivb711().s[42]++;
                                    return (cov_syhivb711().b[11][0]++, terms.length >= 5) && (cov_syhivb711().b[11][1]++, allowedTypes.length > 0) || (cov_syhivb711().b[11][2]++, terms.length === 4) && (cov_syhivb711().b[11][3]++, terms[0].value.match(/^\d+\S*\s\S+\s/) !== null);
                                } else {
                                    cov_syhivb711().b[8][1]++;
                                }
                                cov_syhivb711().s[43]++;
                                return true;
                            }));
                            cov_syhivb711().s[44]++;
                            setPredictions(filtered);
                            _context.n = 7;
                            break;
                        case 6:
                            _context.p = 6;
                            _t = _context.v;
                            cov_syhivb711().s[45]++;
                            clearPredictions();
                            cov_syhivb711().s[46]++;
                            onError === null || onError === void 0 || onError(_t);
                        case 7:
                            return _context.a(2);
                    }
                }, _callee, null, [
                    [
                        3,
                        6
                    ]
                ]);
            }));
            return function(_x) {
                return _ref11.apply(this, arguments);
            };
        }(), DEBOUNCE_INVOKE_WAIT_MS);
    }, [
        sessionToken,
        onError
    ]));
    // Handle external value changes when fetchOnExternalValue is enabled
    cov_syhivb711().s[47]++;
    (0,react.useEffect)(function() {
        cov_syhivb711().f[11]++;
        cov_syhivb711().s[48]++;
        if (!fetchOnExternalValue) {
            cov_syhivb711().b[12][0]++;
            cov_syhivb711().s[49]++;
            return;
        } else {
            cov_syhivb711().b[12][1]++;
        }
        // Skip initial mount - only react to subsequent changes
        cov_syhivb711().s[50]++;
        if (!didMountRef.current) {
            cov_syhivb711().b[13][0]++;
            cov_syhivb711().s[51]++;
            didMountRef.current = true;
            cov_syhivb711().s[52]++;
            return;
        } else {
            cov_syhivb711().b[13][1]++;
        }
        // Sync predictions based on external value change
        cov_syhivb711().s[53]++;
        if (searchTerm === "") {
            cov_syhivb711().b[14][0]++;
            cov_syhivb711().s[54]++;
            clearPredictions();
        } else {
            cov_syhivb711().b[14][1]++;
            cov_syhivb711().s[55]++;
            fetchAutocompleteOptions(searchTerm);
        }
    // clearPredictions is stable (no external dependencies), safe to omit
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchOnExternalValue,
        searchTerm,
        fetchAutocompleteOptions
    ]);
    cov_syhivb711().s[56]++;
    var handleInputChange = function handleInputChange(e) {
        cov_syhivb711().f[12]++;
        var newValue = (cov_syhivb711().s[57]++, e.target.value);
        cov_syhivb711().s[58]++;
        updateSearchTerm(newValue);
        cov_syhivb711().s[59]++;
        fetchAutocompleteOptions(newValue);
        cov_syhivb711().s[60]++;
        if (newValue === "") {
            cov_syhivb711().b[15][0]++;
            cov_syhivb711().s[61]++;
            clearPredictions();
        } else {
            cov_syhivb711().b[15][1]++;
        }
    };
    cov_syhivb711().s[62]++;
    var handlePredictionSelect = /*#__PURE__*/ function() {
        var _ref14 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(prediction) {
            var _inputRef$current;
            var url, response, address, validationResult, _t2, _t3;
            return _regenerator().w(function(_context2) {
                while(1)switch(_context2.p = _context2.n){
                    case 0:
                        cov_syhivb711().f[13]++;
                        cov_syhivb711().s[63]++;
                        // Blur input to dismiss keyboard before async operations that may open modals
                        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
                        cov_syhivb711().s[64]++;
                        setUsedPrediction(prediction);
                        cov_syhivb711().s[65]++;
                        updateSearchTerm(prediction.description);
                        cov_syhivb711().s[66]++;
                        setPredictions([]);
                        cov_syhivb711().s[67]++;
                        setIsLoading(true);
                        url = (cov_syhivb711().s[68]++, prediction.source === "google" ? (cov_syhivb711().b[16][0]++, (0,googleMaps/* buildPlacesUrl */.dl)({
                            source: "google",
                            placeId: prediction.place_id,
                            sessionToken: sessionToken
                        })) : (cov_syhivb711().b[16][1]++, (0,googleMaps/* buildPlacesUrl */.dl)({
                            source: "casa",
                            addressToken: prediction.addressToken,
                            sessionToken: sessionToken
                        })));
                        cov_syhivb711().s[69]++;
                        _context2.p = 1;
                        cov_syhivb711().s[70]++;
                        _context2.n = 2;
                        return fetch(url);
                    case 2:
                        response = _context2.v;
                        cov_syhivb711().s[71]++;
                        _context2.n = 3;
                        return response.json();
                    case 3:
                        address = _context2.v;
                        cov_syhivb711().s[72]++;
                        if (!((cov_syhivb711().b[18][0]++, validateAddress) && (cov_syhivb711().b[18][1]++, onAddressValidated))) {
                            _context2.n = 8;
                            break;
                        }
                        cov_syhivb711().b[17][0]++;
                        cov_syhivb711().s[73]++;
                        _context2.p = 4;
                        cov_syhivb711().s[74]++;
                        _context2.n = 5;
                        return (0,addressValidation/* validateAddress */.YN)(address);
                    case 5:
                        validationResult = _context2.v;
                        cov_syhivb711().s[75]++;
                        onAddressValidated(validationResult);
                        _context2.n = 7;
                        break;
                    case 6:
                        _context2.p = 6;
                        _t2 = _context2.v;
                        cov_syhivb711().s[76]++;
                        onError === null || onError === void 0 || onError(_t2);
                    case 7:
                        _context2.n = 9;
                        break;
                    case 8:
                        cov_syhivb711().b[17][1]++;
                    case 9:
                        cov_syhivb711().s[77]++;
                        onAddressSelect(address);
                        _context2.n = 11;
                        break;
                    case 10:
                        _context2.p = 10;
                        _t3 = _context2.v;
                        cov_syhivb711().s[78]++;
                        onError === null || onError === void 0 || onError(_t3);
                    case 11:
                        _context2.p = 11;
                        cov_syhivb711().s[79]++;
                        setIsLoading(false);
                        return _context2.f(11);
                    case 12:
                        return _context2.a(2);
                }
            }, _callee2, null, [
                [
                    4,
                    6
                ],
                [
                    1,
                    10,
                    11,
                    12
                ]
            ]);
        }));
        return function handlePredictionSelect(_x2) {
            return _ref14.apply(this, arguments);
        };
    }();
    cov_syhivb711().s[80]++;
    var renderItem = function renderItem(prediction) {
        cov_syhivb711().f[14]++;
        // Map size to typography for consistent styling
        var typographyMap = (cov_syhivb711().s[81]++, {
            xsmall: "$bodyMedium",
            small: "$bodyMedium",
            medium: "$bodyLarge",
            large: "$bodyXlarge"
        });
        var typography = (cov_syhivb711().s[82]++, size ? (cov_syhivb711().b[19][0]++, typographyMap[size]) : (cov_syhivb711().b[19][1]++, "$bodyXlarge"));
        cov_syhivb711().s[83]++;
        return /*#__PURE__*/ react.createElement(Text/* Text */.x, {
            typography: typography,
            tag: "span",
            textAlign: "left",
            $smallerThanMD: {
                typography: "$bodyMedium"
            },
            px: 10,
            py: 2
        }, prediction.description);
    };
    var displayIcon = (cov_syhivb711().s[84]++, (_ref15 = (cov_syhivb711().b[20][0]++, icon)) !== null && _ref15 !== void 0 ? _ref15 : (cov_syhivb711().b[20][1]++, isLoading ? (cov_syhivb711().b[21][0]++, /*#__PURE__*/ react.createElement(Box/* default */.Z, {
        position: "relative",
        px: 5
    }, /*#__PURE__*/ react.createElement(Button/* ButtonLoadingAnimation */.V, {
        variant: "secondary",
        size: "xsmall"
    }))) : (cov_syhivb711().b[21][1]++, /*#__PURE__*/ react.createElement(Search/* default */.Z, null))));
    var useSuffix = (cov_syhivb711().s[85]++, displayIcon);
    cov_syhivb711().s[86]++;
    if (actionButton) {
        cov_syhivb711().b[22][0]++;
        cov_syhivb711().s[87]++;
        var onPress = function onPress() {
            cov_syhivb711().f[15]++;
            cov_syhivb711().s[88]++;
            if ((cov_syhivb711().b[24][0]++, predictions.length) && (cov_syhivb711().b[24][1]++, predictions[0])) {
                cov_syhivb711().b[23][0]++;
                cov_syhivb711().s[89]++;
                handlePredictionSelect(predictions[0]);
            } else {
                cov_syhivb711().b[23][1]++;
                cov_syhivb711().s[90]++;
                if ((cov_syhivb711().b[26][0]++, usedPrediction) && (cov_syhivb711().b[26][1]++, searchTerm === usedPrediction.description)) {
                    cov_syhivb711().b[25][0]++;
                    cov_syhivb711().s[91]++;
                    handlePredictionSelect(usedPrediction);
                } else {
                    cov_syhivb711().b[25][1]++;
                }
            }
        };
        var renderedButton = (cov_syhivb711().s[92]++, actionButton(onPress, isLoading));
        cov_syhivb711().s[93]++;
        useSuffix = renderedButton;
    } else {
        cov_syhivb711().b[22][1]++;
    }
    cov_syhivb711().s[94]++;
    return /*#__PURE__*/ react.createElement(AutocompleteInput/* default */.Z, {
        id: id,
        label: label,
        hideLabel: hideLabel,
        placeholder: placeholder,
        disabled: disabled,
        items: predictions,
        searchTerm: searchTerm,
        onSearchChange: handleInputChange,
        onItemSelect: handlePredictionSelect,
        renderItem: renderItem,
        suffix: useSuffix,
        customAction: customAction,
        listBoxId: listBoxId,
        onEscape: function onEscape() {
            cov_syhivb711().f[16]++;
            cov_syhivb711().s[95]++;
            return clearPredictions();
        },
        onFocus: onFocus,
        onBlur: onBlur,
        listBoxAriaLabel: listBoxAriaLabel,
        size: size,
        supportText: supportText,
        errorText: errorText,
        invalid: invalid,
        required: required,
        inputRef: inputRef
    });
};
/* harmony default export */ var AddressInput_AddressInput = (AddressInput); //# sourceMappingURL=AddressInput.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/core/AddressInput/index.mjs
function cov_2l2hcn5589() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/core/AddressInput/index.ts";
    var hash = "2e617674482a22aeca35155a3708ec77f9e64b42";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/core/AddressInput/index.ts",
        statementMap: {},
        fnMap: {},
        branchMap: {},
        s: {},
        f: {},
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "2e617674482a22aeca35155a3708ec77f9e64b42"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2l2hcn5589 = function cov_2l2hcn5589() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2l2hcn5589();
 //# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 59801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AutocompleteInput_AutocompleteInput; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(2490);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(9924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/TextInput.js
var TextInput = __webpack_require__(94746);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/core/AutocompleteInput/AutocompleteInput.mjs





function cov_2d3ym5fpig() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/core/AutocompleteInput/AutocompleteInput.tsx";
    var hash = "42d22e04262451e6ffdc3854f00a130bc7409ccf";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/core/AutocompleteInput/AutocompleteInput.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 63,
                    column: 23
                },
                end: {
                    line: 65,
                    column: 2
                }
            },
            "1": {
                start: {
                    line: 64,
                    column: 2
                },
                end: {
                    line: 64,
                    column: 46
                }
            },
            "2": {
                start: {
                    line: 67,
                    column: 26
                },
                end: {
                    line: 122,
                    column: 1
                }
            },
            "3": {
                start: {
                    line: 79,
                    column: 26
                },
                end: {
                    line: 83,
                    column: 12
                }
            },
            "4": {
                start: {
                    line: 84,
                    column: 23
                },
                end: {
                    line: 84,
                    column: 85
                }
            },
            "5": {
                start: {
                    line: 86,
                    column: 2
                },
                end: {
                    line: 121,
                    column: 4
                }
            },
            "6": {
                start: {
                    line: 124,
                    column: 26
                },
                end: {
                    line: 317,
                    column: 1
                }
            },
            "7": {
                start: {
                    line: 149,
                    column: 44
                },
                end: {
                    line: 149,
                    column: 83
                }
            },
            "8": {
                start: {
                    line: 150,
                    column: 36
                },
                end: {
                    line: 150,
                    column: 51
                }
            },
            "9": {
                start: {
                    line: 151,
                    column: 24
                },
                end: {
                    line: 151,
                    column: 28
                }
            },
            "10": {
                start: {
                    line: 152,
                    column: 27
                },
                end: {
                    line: 152,
                    column: 57
                }
            },
            "11": {
                start: {
                    line: 153,
                    column: 19
                },
                end: {
                    line: 153,
                    column: 55
                }
            },
            "12": {
                start: {
                    line: 156,
                    column: 2
                },
                end: {
                    line: 160,
                    column: 29
                }
            },
            "13": {
                start: {
                    line: 157,
                    column: 4
                },
                end: {
                    line: 159,
                    column: 5
                }
            },
            "14": {
                start: {
                    line: 158,
                    column: 6
                },
                end: {
                    line: 158,
                    column: 34
                }
            },
            "15": {
                start: {
                    line: 162,
                    column: 27
                },
                end: {
                    line: 168,
                    column: 3
                }
            },
            "16": {
                start: {
                    line: 163,
                    column: 17
                },
                end: {
                    line: 166,
                    column: 5
                }
            },
            "17": {
                start: {
                    line: 164,
                    column: 6
                },
                end: {
                    line: 164,
                    column: 25
                }
            },
            "18": {
                start: {
                    line: 165,
                    column: 6
                },
                end: {
                    line: 165,
                    column: 31
                }
            },
            "19": {
                start: {
                    line: 170,
                    column: 80
                },
                end: {
                    line: 197,
                    column: 3
                }
            },
            "20": {
                start: {
                    line: 171,
                    column: 4
                },
                end: {
                    line: 196,
                    column: 5
                }
            },
            "21": {
                start: {
                    line: 172,
                    column: 6
                },
                end: {
                    line: 172,
                    column: 25
                }
            },
            "22": {
                start: {
                    line: 173,
                    column: 6
                },
                end: {
                    line: 177,
                    column: 7
                }
            },
            "23": {
                start: {
                    line: 175,
                    column: 10
                },
                end: {
                    line: 175,
                    column: 99
                }
            },
            "24": {
                start: {
                    line: 176,
                    column: 8
                },
                end: {
                    line: 176,
                    column: 43
                }
            },
            "25": {
                start: {
                    line: 178,
                    column: 11
                },
                end: {
                    line: 196,
                    column: 5
                }
            },
            "26": {
                start: {
                    line: 179,
                    column: 6
                },
                end: {
                    line: 179,
                    column: 25
                }
            },
            "27": {
                start: {
                    line: 180,
                    column: 6
                },
                end: {
                    line: 184,
                    column: 7
                }
            },
            "28": {
                start: {
                    line: 182,
                    column: 10
                },
                end: {
                    line: 182,
                    column: 99
                }
            },
            "29": {
                start: {
                    line: 183,
                    column: 8
                },
                end: {
                    line: 183,
                    column: 43
                }
            },
            "30": {
                start: {
                    line: 185,
                    column: 11
                },
                end: {
                    line: 196,
                    column: 5
                }
            },
            "31": {
                start: {
                    line: 186,
                    column: 6
                },
                end: {
                    line: 186,
                    column: 25
                }
            },
            "32": {
                start: {
                    line: 187,
                    column: 6
                },
                end: {
                    line: 190,
                    column: 7
                }
            },
            "33": {
                start: {
                    line: 188,
                    column: 8
                },
                end: {
                    line: 188,
                    column: 43
                }
            },
            "34": {
                start: {
                    line: 189,
                    column: 8
                },
                end: {
                    line: 189,
                    column: 33
                }
            },
            "35": {
                start: {
                    line: 191,
                    column: 11
                },
                end: {
                    line: 196,
                    column: 5
                }
            },
            "36": {
                start: {
                    line: 192,
                    column: 6
                },
                end: {
                    line: 192,
                    column: 34
                }
            },
            "37": {
                start: {
                    line: 193,
                    column: 6
                },
                end: {
                    line: 193,
                    column: 19
                }
            },
            "38": {
                start: {
                    line: 195,
                    column: 6
                },
                end: {
                    line: 195,
                    column: 34
                }
            },
            "39": {
                start: {
                    line: 199,
                    column: 30
                },
                end: {
                    line: 207,
                    column: 3
                }
            },
            "40": {
                start: {
                    line: 201,
                    column: 6
                },
                end: {
                    line: 204,
                    column: 7
                }
            },
            "41": {
                start: {
                    line: 202,
                    column: 8
                },
                end: {
                    line: 202,
                    column: 28
                }
            },
            "42": {
                start: {
                    line: 203,
                    column: 8
                },
                end: {
                    line: 203,
                    column: 19
                }
            },
            "43": {
                start: {
                    line: 209,
                    column: 31
                },
                end: {
                    line: 212,
                    column: 15
                }
            },
            "44": {
                start: {
                    line: 210,
                    column: 4
                },
                end: {
                    line: 210,
                    column: 23
                }
            },
            "45": {
                start: {
                    line: 211,
                    column: 4
                },
                end: {
                    line: 211,
                    column: 16
                }
            },
            "46": {
                start: {
                    line: 214,
                    column: 26
                },
                end: {
                    line: 216,
                    column: 8
                }
            },
            "47": {
                start: {
                    line: 215,
                    column: 4
                },
                end: {
                    line: 215,
                    column: 23
                }
            },
            "48": {
                start: {
                    line: 218,
                    column: 23
                },
                end: {
                    line: 218,
                    column: 53
                }
            },
            "49": {
                start: {
                    line: 220,
                    column: 2
                },
                end: {
                    line: 314,
                    column: 3
                }
            },
            "50": {
                start: {
                    line: 221,
                    column: 32
                },
                end: {
                    line: 243,
                    column: 5
                }
            },
            "51": {
                start: {
                    line: 227,
                    column: 31
                },
                end: {
                    line: 229,
                    column: 48
                }
            },
            "52": {
                start: {
                    line: 230,
                    column: 8
                },
                end: {
                    line: 230,
                    column: 39
                }
            },
            "53": {
                start: {
                    line: 245,
                    column: 4
                },
                end: {
                    line: 251,
                    column: 5
                }
            },
            "54": {
                start: {
                    line: 246,
                    column: 6
                },
                end: {
                    line: 246,
                    column: 35
                }
            },
            "55": {
                start: {
                    line: 247,
                    column: 11
                },
                end: {
                    line: 251,
                    column: 5
                }
            },
            "56": {
                start: {
                    line: 248,
                    column: 6
                },
                end: {
                    line: 248,
                    column: 39
                }
            },
            "57": {
                start: {
                    line: 250,
                    column: 6
                },
                end: {
                    line: 250,
                    column: 48
                }
            },
            "58": {
                start: {
                    line: 254,
                    column: 4
                },
                end: {
                    line: 260,
                    column: 5
                }
            },
            "59": {
                start: {
                    line: 255,
                    column: 6
                },
                end: {
                    line: 259,
                    column: 8
                }
            },
            "60": {
                start: {
                    line: 262,
                    column: 4
                },
                end: {
                    line: 313,
                    column: 6
                }
            },
            "61": {
                start: {
                    line: 271,
                    column: 35
                },
                end: {
                    line: 271,
                    column: 58
                }
            },
            "62": {
                start: {
                    line: 273,
                    column: 16
                },
                end: {
                    line: 306,
                    column: 18
                }
            },
            "63": {
                start: {
                    line: 316,
                    column: 2
                },
                end: {
                    line: 316,
                    column: 14
                }
            }
        },
        fnMap: {
            "0": {
                name: "ListBoxElement",
                decl: {
                    start: {
                        line: 63,
                        column: 49
                    },
                    end: {
                        line: 63,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 63,
                        column: 90
                    },
                    end: {
                        line: 65,
                        column: 1
                    }
                },
                line: 63
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 67,
                        column: 26
                    },
                    end: {
                        line: 67,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 77,
                        column: 6
                    },
                    end: {
                        line: 122,
                        column: 1
                    }
                },
                line: 77
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 124,
                        column: 26
                    },
                    end: {
                        line: 124,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 148,
                        column: 33
                    },
                    end: {
                        line: 317,
                        column: 1
                    }
                },
                line: 148
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 156,
                        column: 12
                    },
                    end: {
                        line: 156,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 156,
                        column: 18
                    },
                    end: {
                        line: 160,
                        column: 3
                    }
                },
                line: 156
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 163,
                        column: 4
                    },
                    end: {
                        line: 163,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 163,
                        column: 17
                    },
                    end: {
                        line: 166,
                        column: 5
                    }
                },
                line: 163
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 163,
                        column: 17
                    },
                    end: {
                        line: 163,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 163,
                        column: 23
                    },
                    end: {
                        line: 166,
                        column: 5
                    }
                },
                line: 163
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 170,
                        column: 80
                    },
                    end: {
                        line: 170,
                        column: 81
                    }
                },
                loc: {
                    start: {
                        line: 170,
                        column: 87
                    },
                    end: {
                        line: 197,
                        column: 3
                    }
                },
                line: 170
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 200,
                        column: 4
                    },
                    end: {
                        line: 200,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 200,
                        column: 45
                    },
                    end: {
                        line: 205,
                        column: 5
                    }
                },
                line: 200
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 209,
                        column: 43
                    },
                    end: {
                        line: 209,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 209,
                        column: 49
                    },
                    end: {
                        line: 212,
                        column: 3
                    }
                },
                line: 209
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 214,
                        column: 38
                    },
                    end: {
                        line: 214,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 214,
                        column: 63
                    },
                    end: {
                        line: 216,
                        column: 3
                    }
                },
                line: 214
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 226,
                        column: 20
                    },
                    end: {
                        line: 226,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 226,
                        column: 38
                    },
                    end: {
                        line: 231,
                        column: 7
                    }
                },
                line: 226
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 270,
                        column: 25
                    },
                    end: {
                        line: 270,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 270,
                        column: 42
                    },
                    end: {
                        line: 307,
                        column: 15
                    }
                },
                line: 270
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 70,
                        column: 2
                    },
                    end: {
                        line: 70,
                        column: 27
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 70,
                            column: 14
                        },
                        end: {
                            line: 70,
                            column: 27
                        }
                    }
                ],
                line: 70
            },
            "1": {
                loc: {
                    start: {
                        line: 71,
                        column: 2
                    },
                    end: {
                        line: 71,
                        column: 17
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 71,
                            column: 9
                        },
                        end: {
                            line: 71,
                            column: 17
                        }
                    }
                ],
                line: 71
            },
            "2": {
                loc: {
                    start: {
                        line: 84,
                        column: 23
                    },
                    end: {
                        line: 84,
                        column: 85
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 84,
                            column: 23
                        },
                        end: {
                            line: 84,
                            column: 76
                        }
                    },
                    {
                        start: {
                            line: 84,
                            column: 80
                        },
                        end: {
                            line: 84,
                            column: 85
                        }
                    }
                ],
                line: 84
            },
            "3": {
                loc: {
                    start: {
                        line: 137,
                        column: 2
                    },
                    end: {
                        line: 137,
                        column: 36
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 137,
                            column: 14
                        },
                        end: {
                            line: 137,
                            column: 36
                        }
                    }
                ],
                line: 137
            },
            "4": {
                loc: {
                    start: {
                        line: 142,
                        column: 2
                    },
                    end: {
                        line: 142,
                        column: 17
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 142,
                            column: 9
                        },
                        end: {
                            line: 142,
                            column: 17
                        }
                    }
                ],
                line: 142
            },
            "5": {
                loc: {
                    start: {
                        line: 153,
                        column: 19
                    },
                    end: {
                        line: 153,
                        column: 55
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 153,
                            column: 19
                        },
                        end: {
                            line: 153,
                            column: 35
                        }
                    },
                    {
                        start: {
                            line: 153,
                            column: 39
                        },
                        end: {
                            line: 153,
                            column: 55
                        }
                    }
                ],
                line: 153
            },
            "6": {
                loc: {
                    start: {
                        line: 157,
                        column: 4
                    },
                    end: {
                        line: 159,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 157,
                            column: 4
                        },
                        end: {
                            line: 159,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 157
            },
            "7": {
                loc: {
                    start: {
                        line: 157,
                        column: 8
                    },
                    end: {
                        line: 157,
                        column: 68
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 157,
                            column: 8
                        },
                        end: {
                            line: 157,
                            column: 35
                        }
                    },
                    {
                        start: {
                            line: 157,
                            column: 39
                        },
                        end: {
                            line: 157,
                            column: 68
                        }
                    }
                ],
                line: 157
            },
            "8": {
                loc: {
                    start: {
                        line: 171,
                        column: 4
                    },
                    end: {
                        line: 196,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 171,
                            column: 4
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 178,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    }
                ],
                line: 171
            },
            "9": {
                loc: {
                    start: {
                        line: 173,
                        column: 6
                    },
                    end: {
                        line: 177,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 173,
                            column: 6
                        },
                        end: {
                            line: 177,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 173
            },
            "10": {
                loc: {
                    start: {
                        line: 175,
                        column: 10
                    },
                    end: {
                        line: 175,
                        column: 99
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 175,
                            column: 78
                        },
                        end: {
                            line: 175,
                            column: 79
                        }
                    },
                    {
                        start: {
                            line: 175,
                            column: 82
                        },
                        end: {
                            line: 175,
                            column: 99
                        }
                    }
                ],
                line: 175
            },
            "11": {
                loc: {
                    start: {
                        line: 175,
                        column: 10
                    },
                    end: {
                        line: 175,
                        column: 75
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 175,
                            column: 10
                        },
                        end: {
                            line: 175,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 175,
                            column: 41
                        },
                        end: {
                            line: 175,
                            column: 75
                        }
                    }
                ],
                line: 175
            },
            "12": {
                loc: {
                    start: {
                        line: 178,
                        column: 11
                    },
                    end: {
                        line: 196,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 178,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 185,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    }
                ],
                line: 178
            },
            "13": {
                loc: {
                    start: {
                        line: 180,
                        column: 6
                    },
                    end: {
                        line: 184,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 180,
                            column: 6
                        },
                        end: {
                            line: 184,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 180
            },
            "14": {
                loc: {
                    start: {
                        line: 182,
                        column: 10
                    },
                    end: {
                        line: 182,
                        column: 99
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 182,
                            column: 63
                        },
                        end: {
                            line: 182,
                            column: 79
                        }
                    },
                    {
                        start: {
                            line: 182,
                            column: 82
                        },
                        end: {
                            line: 182,
                            column: 99
                        }
                    }
                ],
                line: 182
            },
            "15": {
                loc: {
                    start: {
                        line: 182,
                        column: 10
                    },
                    end: {
                        line: 182,
                        column: 60
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 182,
                            column: 10
                        },
                        end: {
                            line: 182,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 182,
                            column: 41
                        },
                        end: {
                            line: 182,
                            column: 60
                        }
                    }
                ],
                line: 182
            },
            "16": {
                loc: {
                    start: {
                        line: 185,
                        column: 11
                    },
                    end: {
                        line: 196,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 185,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 191,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    }
                ],
                line: 185
            },
            "17": {
                loc: {
                    start: {
                        line: 187,
                        column: 6
                    },
                    end: {
                        line: 190,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 187,
                            column: 6
                        },
                        end: {
                            line: 190,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 187
            },
            "18": {
                loc: {
                    start: {
                        line: 187,
                        column: 10
                    },
                    end: {
                        line: 187,
                        column: 61
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 187,
                            column: 10
                        },
                        end: {
                            line: 187,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 187,
                            column: 41
                        },
                        end: {
                            line: 187,
                            column: 61
                        }
                    }
                ],
                line: 187
            },
            "19": {
                loc: {
                    start: {
                        line: 191,
                        column: 11
                    },
                    end: {
                        line: 196,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 191,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 194,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    }
                ],
                line: 191
            },
            "20": {
                loc: {
                    start: {
                        line: 201,
                        column: 6
                    },
                    end: {
                        line: 204,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 201,
                            column: 6
                        },
                        end: {
                            line: 204,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 201
            },
            "21": {
                loc: {
                    start: {
                        line: 218,
                        column: 23
                    },
                    end: {
                        line: 218,
                        column: 53
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 218,
                            column: 23
                        },
                        end: {
                            line: 218,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 218,
                            column: 44
                        },
                        end: {
                            line: 218,
                            column: 53
                        }
                    }
                ],
                line: 218
            },
            "22": {
                loc: {
                    start: {
                        line: 220,
                        column: 2
                    },
                    end: {
                        line: 314,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 220,
                            column: 2
                        },
                        end: {
                            line: 314,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 220
            },
            "23": {
                loc: {
                    start: {
                        line: 241,
                        column: 23
                    },
                    end: {
                        line: 241,
                        column: 54
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 241,
                            column: 38
                        },
                        end: {
                            line: 241,
                            column: 44
                        }
                    },
                    {
                        start: {
                            line: 241,
                            column: 47
                        },
                        end: {
                            line: 241,
                            column: 54
                        }
                    }
                ],
                line: 241
            },
            "24": {
                loc: {
                    start: {
                        line: 245,
                        column: 4
                    },
                    end: {
                        line: 251,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 245,
                            column: 4
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 247,
                            column: 11
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    }
                ],
                line: 245
            },
            "25": {
                loc: {
                    start: {
                        line: 245,
                        column: 8
                    },
                    end: {
                        line: 245,
                        column: 27
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 245,
                            column: 8
                        },
                        end: {
                            line: 245,
                            column: 18
                        }
                    },
                    {
                        start: {
                            line: 245,
                            column: 22
                        },
                        end: {
                            line: 245,
                            column: 27
                        }
                    }
                ],
                line: 245
            },
            "26": {
                loc: {
                    start: {
                        line: 247,
                        column: 11
                    },
                    end: {
                        line: 251,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 247,
                            column: 11
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 249,
                            column: 11
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    }
                ],
                line: 247
            },
            "27": {
                loc: {
                    start: {
                        line: 254,
                        column: 4
                    },
                    end: {
                        line: 260,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 254,
                            column: 4
                        },
                        end: {
                            line: 260,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 254
            },
            "28": {
                loc: {
                    start: {
                        line: 254,
                        column: 8
                    },
                    end: {
                        line: 254,
                        column: 58
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 254,
                            column: 8
                        },
                        end: {
                            line: 254,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 254,
                            column: 25
                        },
                        end: {
                            line: 254,
                            column: 41
                        }
                    },
                    {
                        start: {
                            line: 254,
                            column: 45
                        },
                        end: {
                            line: 254,
                            column: 57
                        }
                    }
                ],
                line: 254
            },
            "29": {
                loc: {
                    start: {
                        line: 268,
                        column: 11
                    },
                    end: {
                        line: 310,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 268,
                            column: 11
                        },
                        end: {
                            line: 268,
                            column: 23
                        }
                    },
                    {
                        start: {
                            line: 268,
                            column: 28
                        },
                        end: {
                            line: 268,
                            column: 44
                        }
                    },
                    {
                        start: {
                            line: 268,
                            column: 48
                        },
                        end: {
                            line: 268,
                            column: 60
                        }
                    },
                    {
                        start: {
                            line: 269,
                            column: 12
                        },
                        end: {
                            line: 309,
                            column: 32
                        }
                    }
                ],
                line: 268
            },
            "30": {
                loc: {
                    start: {
                        line: 279,
                        column: 35
                    },
                    end: {
                        line: 279,
                        column: 58
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 279,
                            column: 35
                        },
                        end: {
                            line: 279,
                            column: 45
                        }
                    },
                    {
                        start: {
                            line: 279,
                            column: 49
                        },
                        end: {
                            line: 279,
                            column: 58
                        }
                    }
                ],
                line: 279
            },
            "31": {
                loc: {
                    start: {
                        line: 292,
                        column: 24
                    },
                    end: {
                        line: 292,
                        column: 90
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 292,
                            column: 37
                        },
                        end: {
                            line: 292,
                            column: 67
                        }
                    },
                    {
                        start: {
                            line: 292,
                            column: 70
                        },
                        end: {
                            line: 292,
                            column: 90
                        }
                    }
                ],
                line: 292
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0,
            "54": 0,
            "55": 0,
            "56": 0,
            "57": 0,
            "58": 0,
            "59": 0,
            "60": 0,
            "61": 0,
            "62": 0,
            "63": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0
            ],
            "4": [
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ],
            "10": [
                0,
                0
            ],
            "11": [
                0,
                0
            ],
            "12": [
                0,
                0
            ],
            "13": [
                0,
                0
            ],
            "14": [
                0,
                0
            ],
            "15": [
                0,
                0
            ],
            "16": [
                0,
                0
            ],
            "17": [
                0,
                0
            ],
            "18": [
                0,
                0
            ],
            "19": [
                0,
                0
            ],
            "20": [
                0,
                0
            ],
            "21": [
                0,
                0
            ],
            "22": [
                0,
                0
            ],
            "23": [
                0,
                0
            ],
            "24": [
                0,
                0
            ],
            "25": [
                0,
                0
            ],
            "26": [
                0,
                0
            ],
            "27": [
                0,
                0
            ],
            "28": [
                0,
                0,
                0
            ],
            "29": [
                0,
                0,
                0,
                0
            ],
            "30": [
                0,
                0
            ],
            "31": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "42d22e04262451e6ffdc3854f00a130bc7409ccf"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2d3ym5fpig = function cov_2d3ym5fpig() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}


cov_2d3ym5fpig();










function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}


// Simple wrapper component similar to PickerSelect's approach
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var ListBoxElement = (cov_2d3ym5fpig().s[0]++, /*#__PURE__*/ react.forwardRef(function ListBoxElement(props, forwardedRef) {
    cov_2d3ym5fpig().f[0]++;
    cov_2d3ym5fpig().s[1]++;
    return /*#__PURE__*/ react.createElement("ul", _extends({}, props, {
        ref: forwardedRef
    }));
}));
cov_2d3ym5fpig().s[2]++;
var BricksNextListBox = function BricksNextListBox(_ref) {
    var children = _ref.children, listBoxId = _ref.listBoxId, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? (cov_2d3ym5fpig().b[0][0]++, "suggestions") : _ref$ariaLabel, _ref$size = _ref.size, size = _ref$size === void 0 ? (cov_2d3ym5fpig().b[1][0]++, "medium") : _ref$size;
    cov_2d3ym5fpig().f[1]++;
    // Map size to border radius tokens that match TextInput
    var borderRadiusMap = (cov_2d3ym5fpig().s[3]++, {
        small: "$7x",
        medium: "$9x",
        large: "$12x"
    });
    var borderRadius = (cov_2d3ym5fpig().s[4]++, (cov_2d3ym5fpig().b[2][0]++, borderRadiusMap[size]) || (cov_2d3ym5fpig().b[2][1]++, "$9x"));
    cov_2d3ym5fpig().s[5]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        borderBottomLeftRadius: borderRadius,
        borderBottomRightRadius: borderRadius,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        maxHeight: 450,
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        marginTop: -1.5,
        borderLeftWidth: 1.5,
        borderRightWidth: 1.5,
        borderBottomWidth: 1.5,
        borderTopWidth: 0,
        borderStyle: "solid",
        borderColor: "$borderAccentBrand",
        backgroundColor: "$backgroundPrimary",
        overflow: "hidden",
        zIndex: 1000
    }, /*#__PURE__*/ react.createElement(ListBoxElement, {
        role: "listbox",
        "aria-label": ariaLabel,
        id: listBoxId,
        style: {
            padding: 0,
            margin: 0,
            listStyleType: "none"
        }
    }, children));
};
cov_2d3ym5fpig().s[6]++;
var AutocompleteInput = function AutocompleteInput(_ref2) {
    var id = _ref2.id, label = _ref2.label, hideLabel = _ref2.hideLabel, placeholder = _ref2.placeholder, disabled = _ref2.disabled, items = _ref2.items, searchTerm = _ref2.searchTerm, onSearchChange = _ref2.onSearchChange, onItemSelect = _ref2.onItemSelect, renderItem = _ref2.renderItem, suffix = _ref2.suffix, customAction = _ref2.customAction, _ref2$listBoxId = _ref2.listBoxId, listBoxId = _ref2$listBoxId === void 0 ? (cov_2d3ym5fpig().b[3][0]++, "autocomplete-listbox") : _ref2$listBoxId, listBoxAriaLabel = _ref2.listBoxAriaLabel, onEscape = _ref2.onEscape, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (cov_2d3ym5fpig().b[4][0]++, "medium") : _ref2$size, supportText = _ref2.supportText, errorText = _ref2.errorText, invalid = _ref2.invalid, required = _ref2.required, externalInputRef = _ref2.inputRef;
    cov_2d3ym5fpig().f[2]++;
    var _ref3 = (cov_2d3ym5fpig().s[7]++, (0,react.useState)(undefined)), _ref4 = _slicedToArray(_ref3, 2), selectedIndex = _ref4[0], setSelectedIndex = _ref4[1];
    var _ref5 = (cov_2d3ym5fpig().s[8]++, (0,react.useState)(false)), _ref6 = _slicedToArray(_ref5, 2), isFocused = _ref6[0], setIsFocused = _ref6[1];
    var useBricksNext = (cov_2d3ym5fpig().s[9]++, true);
    var internalInputRef = (cov_2d3ym5fpig().s[10]++, (0,react.useRef)(null));
    var inputRef = (cov_2d3ym5fpig().s[11]++, (cov_2d3ym5fpig().b[5][0]++, externalInputRef) || (cov_2d3ym5fpig().b[5][1]++, internalInputRef));
    // Reset selection when items change to prevent stale index
    cov_2d3ym5fpig().s[12]++;
    (0,react.useEffect)(function() {
        cov_2d3ym5fpig().f[3]++;
        cov_2d3ym5fpig().s[13]++;
        if ((cov_2d3ym5fpig().b[7][0]++, selectedIndex !== undefined) && (cov_2d3ym5fpig().b[7][1]++, selectedIndex >= items.length)) {
            cov_2d3ym5fpig().b[6][0]++;
            cov_2d3ym5fpig().s[14]++;
            setSelectedIndex(undefined);
        } else {
            cov_2d3ym5fpig().b[6][1]++;
        }
    }, [
        items,
        selectedIndex
    ]);
    var handleItemSelect = (cov_2d3ym5fpig().s[15]++, (0,react.useCallback)(function(item) {
        cov_2d3ym5fpig().f[4]++;
        cov_2d3ym5fpig().s[16]++;
        return function() {
            var _inputRef$current;
            cov_2d3ym5fpig().f[5]++;
            cov_2d3ym5fpig().s[17]++;
            onItemSelect(item);
            cov_2d3ym5fpig().s[18]++;
            (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
        };
    }, [
        onItemSelect,
        inputRef
    ]));
    cov_2d3ym5fpig().s[19]++;
    var onKeyDown = function onKeyDown(e) {
        cov_2d3ym5fpig().f[6]++;
        cov_2d3ym5fpig().s[20]++;
        if (e.key === "ArrowDown") {
            cov_2d3ym5fpig().b[8][0]++;
            cov_2d3ym5fpig().s[21]++;
            e.preventDefault();
            cov_2d3ym5fpig().s[22]++;
            if (items.length > 0) {
                cov_2d3ym5fpig().b[9][0]++;
                var newSelectedIndex = (cov_2d3ym5fpig().s[23]++, (cov_2d3ym5fpig().b[11][0]++, selectedIndex === undefined) || (cov_2d3ym5fpig().b[11][1]++, selectedIndex === items.length - 1) ? (cov_2d3ym5fpig().b[10][0]++, 0) : (cov_2d3ym5fpig().b[10][1]++, selectedIndex + 1));
                cov_2d3ym5fpig().s[24]++;
                setSelectedIndex(newSelectedIndex);
            } else {
                cov_2d3ym5fpig().b[9][1]++;
            }
        } else {
            cov_2d3ym5fpig().b[8][1]++;
            cov_2d3ym5fpig().s[25]++;
            if (e.key === "ArrowUp") {
                cov_2d3ym5fpig().b[12][0]++;
                cov_2d3ym5fpig().s[26]++;
                e.preventDefault();
                cov_2d3ym5fpig().s[27]++;
                if (items.length > 0) {
                    cov_2d3ym5fpig().b[13][0]++;
                    var _newSelectedIndex = (cov_2d3ym5fpig().s[28]++, (cov_2d3ym5fpig().b[15][0]++, selectedIndex === undefined) || (cov_2d3ym5fpig().b[15][1]++, selectedIndex === 0) ? (cov_2d3ym5fpig().b[14][0]++, items.length - 1) : (cov_2d3ym5fpig().b[14][1]++, selectedIndex - 1));
                    cov_2d3ym5fpig().s[29]++;
                    setSelectedIndex(_newSelectedIndex);
                } else {
                    cov_2d3ym5fpig().b[13][1]++;
                }
            } else {
                cov_2d3ym5fpig().b[12][1]++;
                cov_2d3ym5fpig().s[30]++;
                if (e.key === "Enter") {
                    cov_2d3ym5fpig().b[16][0]++;
                    cov_2d3ym5fpig().s[31]++;
                    e.preventDefault();
                    cov_2d3ym5fpig().s[32]++;
                    if ((cov_2d3ym5fpig().b[18][0]++, selectedIndex !== undefined) && (cov_2d3ym5fpig().b[18][1]++, items[selectedIndex])) {
                        var _inputRef$current2;
                        cov_2d3ym5fpig().b[17][0]++;
                        cov_2d3ym5fpig().s[33]++;
                        onItemSelect(items[selectedIndex]);
                        cov_2d3ym5fpig().s[34]++;
                        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
                    } else {
                        cov_2d3ym5fpig().b[17][1]++;
                    }
                } else {
                    cov_2d3ym5fpig().b[16][1]++;
                    cov_2d3ym5fpig().s[35]++;
                    if (e.key === "Escape") {
                        cov_2d3ym5fpig().b[19][0]++;
                        cov_2d3ym5fpig().s[36]++;
                        setSelectedIndex(undefined);
                        cov_2d3ym5fpig().s[37]++;
                        onEscape === null || onEscape === void 0 || onEscape();
                    } else {
                        cov_2d3ym5fpig().b[19][1]++;
                        cov_2d3ym5fpig().s[38]++;
                        setSelectedIndex(undefined);
                    }
                }
            }
        }
    };
    var handleContainerBlur = (cov_2d3ym5fpig().s[39]++, (0,react.useCallback)(function(e) {
        cov_2d3ym5fpig().f[7]++;
        cov_2d3ym5fpig().s[40]++;
        if (!e.currentTarget.contains(e.relatedTarget)) {
            cov_2d3ym5fpig().b[20][0]++;
            cov_2d3ym5fpig().s[41]++;
            setIsFocused(false);
            cov_2d3ym5fpig().s[42]++;
            onBlur === null || onBlur === void 0 || onBlur();
        } else {
            cov_2d3ym5fpig().b[20][1]++;
        }
    }, [
        onBlur
    ]));
    var handleContainerFocus = (cov_2d3ym5fpig().s[43]++, (0,react.useCallback)(function() {
        cov_2d3ym5fpig().f[8]++;
        cov_2d3ym5fpig().s[44]++;
        setIsFocused(true);
        cov_2d3ym5fpig().s[45]++;
        onFocus === null || onFocus === void 0 || onFocus();
    }, [
        onFocus
    ]));
    var handleMouseDown = (cov_2d3ym5fpig().s[46]++, (0,react.useCallback)(function(e) {
        cov_2d3ym5fpig().f[9]++;
        cov_2d3ym5fpig().s[47]++;
        e.preventDefault();
    }, []));
    var showDropdown = (cov_2d3ym5fpig().s[48]++, (cov_2d3ym5fpig().b[21][0]++, searchTerm !== "") && (cov_2d3ym5fpig().b[21][1]++, isFocused));
    cov_2d3ym5fpig().s[49]++;
    if (useBricksNext) {
        cov_2d3ym5fpig().b[22][0]++;
        var textInputProps = (cov_2d3ym5fpig().s[50]++, {
            id: id,
            placeholder: placeholder,
            disabled: disabled,
            value: searchTerm,
            onChangeText: function onChangeText(text) {
                cov_2d3ym5fpig().f[10]++;
                var syntheticEvent = (cov_2d3ym5fpig().s[51]++, {
                    target: {
                        value: text
                    }
                });
                cov_2d3ym5fpig().s[52]++;
                onSearchChange(syntheticEvent);
            },
            onKeyPress: onKeyDown,
            size: size,
            supportText: supportText,
            errorText: errorText,
            invalid: invalid,
            required: required,
            autoComplete: "off",
            role: "combobox",
            "aria-autocomplete": "list",
            "aria-expanded": showDropdown ? (cov_2d3ym5fpig().b[23][0]++, "true") : (cov_2d3ym5fpig().b[23][1]++, "false"),
            "aria-controls": listBoxId
        });
        cov_2d3ym5fpig().s[53]++;
        if ((cov_2d3ym5fpig().b[25][0]++, !hideLabel) && (cov_2d3ym5fpig().b[25][1]++, label)) {
            cov_2d3ym5fpig().b[24][0]++;
            cov_2d3ym5fpig().s[54]++;
            textInputProps.title = label;
        } else {
            cov_2d3ym5fpig().b[24][1]++;
            cov_2d3ym5fpig().s[55]++;
            if (label) {
                cov_2d3ym5fpig().b[26][0]++;
                cov_2d3ym5fpig().s[56]++;
                textInputProps.ariaLabel = label;
            } else {
                cov_2d3ym5fpig().b[26][1]++;
                cov_2d3ym5fpig().s[57]++;
                textInputProps.ariaLabel = "Search input";
            }
        }
        // Modify border styling when dropdown is showing AND there are items or customAction to display
        cov_2d3ym5fpig().s[58]++;
        if ((cov_2d3ym5fpig().b[28][0]++, showDropdown) && ((cov_2d3ym5fpig().b[28][1]++, items.length > 0) || (cov_2d3ym5fpig().b[28][2]++, customAction))) {
            cov_2d3ym5fpig().b[27][0]++;
            cov_2d3ym5fpig().s[59]++;
            textInputProps.frameProps = {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomWidth: 0
            };
        } else {
            cov_2d3ym5fpig().b[27][1]++;
        }
        cov_2d3ym5fpig().s[60]++;
        return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            onFocus: handleContainerFocus,
            onBlur: handleContainerBlur
        }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            position: "relative"
        }, /*#__PURE__*/ react.createElement(TextInput/* TextInput */.o, _extends({}, textInputProps, {
            ref: inputRef
        }), suffix), (cov_2d3ym5fpig().b[29][0]++, showDropdown) && ((cov_2d3ym5fpig().b[29][1]++, items.length > 0) || (cov_2d3ym5fpig().b[29][2]++, customAction)) && (cov_2d3ym5fpig().b[29][3]++, /*#__PURE__*/ react.createElement(BricksNextListBox, {
            listBoxId: listBoxId,
            ariaLabel: listBoxAriaLabel,
            size: size
        }, items.map(function(item, index) {
            cov_2d3ym5fpig().f[11]++;
            var isSelected = (cov_2d3ym5fpig().s[61]++, selectedIndex === index);
            cov_2d3ym5fpig().s[62]++;
            return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                tag: "li",
                id: "autocomplete-options",
                key: item.id,
                role: "option",
                "aria-selected": (cov_2d3ym5fpig().b[30][0]++, isSelected) || (cov_2d3ym5fpig().b[30][1]++, undefined),
                overflow: "hidden"
            }, /*#__PURE__*/ react.createElement(PressableBox/* PressableBox */.K, {
                zIndex: 2,
                justifyContent: "flex-start",
                onMouseDown: handleMouseDown,
                analyticsName: "",
                "aria-label": item.ariaLabel,
                animation: "accelerateDecelerateFastest",
                height: "100%",
                width: "100%",
                backgroundColor: isSelected ? (cov_2d3ym5fpig().b[31][0]++, "$backgroundStateHoverPrimary") : (cov_2d3ym5fpig().b[31][1]++, "$backgroundPrimary"),
                hoverStyle: {
                    backgroundColor: "$backgroundStateHoverPrimary"
                },
                onPress: handleItemSelect(item),
                pressStyle: {
                    scale: 0.98
                },
                padding: 10
            }, renderItem(item, isSelected)));
        }), customAction))));
    } else {
        cov_2d3ym5fpig().b[22][1]++;
    }
    cov_2d3ym5fpig().s[63]++;
    return null;
};
/* harmony default export */ var AutocompleteInput_AutocompleteInput = (AutocompleteInput); //# sourceMappingURL=AutocompleteInput.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/core/AutocompleteInput/index.mjs
function cov_2pqjou4oun() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/core/AutocompleteInput/index.ts";
    var hash = "26acc1560eef7397cf15218a46ff8dceb36a6560";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/core/AutocompleteInput/index.ts",
        statementMap: {},
        fnMap: {},
        branchMap: {},
        s: {},
        f: {},
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "26acc1560eef7397cf15218a46ff8dceb36a6560"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2pqjou4oun = function cov_2pqjou4oun() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2pqjou4oun();
 //# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 99835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ buildAutocompleteUrl; },
/* harmony export */   "MF": function() { return /* binding */ ALLOWED_TYPES; },
/* harmony export */   "dl": function() { return /* binding */ buildPlacesUrl; },
/* harmony export */   "h_": function() { return /* binding */ generateGoogleMapsSessionToken; },
/* harmony export */   "wC": function() { return /* binding */ buildCityAutocompleteUrl; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_max_safe_integer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44363);
/* harmony import */ var core_js_modules_es_number_max_safe_integer_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_max_safe_integer_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _globals_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47254);
function cov_1ztovhr6l5() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/helpers/googleMaps.ts";
    var hash = "450d854b2d0d2d244950f6a46f2256cbd57d7d78";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/helpers/googleMaps.ts",
        statementMap: {
            "0": {
                start: {
                    line: 3,
                    column: 26
                },
                end: {
                    line: 5,
                    column: 49
                }
            },
            "1": {
                start: {
                    line: 7,
                    column: 29
                },
                end: {
                    line: 7,
                    column: 81
                }
            },
            "2": {
                start: {
                    line: 9,
                    column: 46
                },
                end: {
                    line: 11,
                    column: 1
                }
            },
            "3": {
                start: {
                    line: 10,
                    column: 2
                },
                end: {
                    line: 10,
                    column: 72
                }
            },
            "4": {
                start: {
                    line: 13,
                    column: 36
                },
                end: {
                    line: 15,
                    column: 1
                }
            },
            "5": {
                start: {
                    line: 14,
                    column: 2
                },
                end: {
                    line: 14,
                    column: 89
                }
            },
            "6": {
                start: {
                    line: 17,
                    column: 40
                },
                end: {
                    line: 21,
                    column: 1
                }
            },
            "7": {
                start: {
                    line: 18,
                    column: 2
                },
                end: {
                    line: 20,
                    column: 22
                }
            },
            "8": {
                start: {
                    line: 23,
                    column: 30
                },
                end: {
                    line: 39,
                    column: 1
                }
            },
            "9": {
                start: {
                    line: 34,
                    column: 18
                },
                end: {
                    line: 34,
                    column: 46
                }
            },
            "10": {
                start: {
                    line: 35,
                    column: 2
                },
                end: {
                    line: 37,
                    column: 3
                }
            },
            "11": {
                start: {
                    line: 36,
                    column: 4
                },
                end: {
                    line: 36,
                    column: 53
                }
            },
            "12": {
                start: {
                    line: 38,
                    column: 2
                },
                end: {
                    line: 38,
                    column: 70
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 9,
                        column: 46
                    },
                    end: {
                        line: 9,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 52
                    },
                    end: {
                        line: 11,
                        column: 1
                    }
                },
                line: 9
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 13,
                        column: 36
                    },
                    end: {
                        line: 13,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 77
                    },
                    end: {
                        line: 15,
                        column: 1
                    }
                },
                line: 13
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 17,
                        column: 40
                    },
                    end: {
                        line: 17,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 81
                    },
                    end: {
                        line: 21,
                        column: 1
                    }
                },
                line: 17
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 23,
                        column: 30
                    },
                    end: {
                        line: 23,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 6
                    },
                    end: {
                        line: 39,
                        column: 1
                    }
                },
                line: 33
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 3,
                        column: 26
                    },
                    end: {
                        line: 5,
                        column: 49
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 4,
                            column: 4
                        },
                        end: {
                            line: 4,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 5,
                            column: 4
                        },
                        end: {
                            line: 5,
                            column: 49
                        }
                    }
                ],
                line: 3
            },
            "1": {
                loc: {
                    start: {
                        line: 35,
                        column: 2
                    },
                    end: {
                        line: 37,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 35,
                            column: 2
                        },
                        end: {
                            line: 37,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 35
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "450d854b2d0d2d244950f6a46f2256cbd57d7d78"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_1ztovhr6l5 = function cov_1ztovhr6l5() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1ztovhr6l5();





var ADDRESS_INPUT_URL = (cov_1ztovhr6l5().s[0]++, (0,_globals_mjs__WEBPACK_IMPORTED_MODULE_4__/* .isProductionEnv */ .n5)() ? (cov_1ztovhr6l5().b[0][0]++, "/_address-input") : (cov_1ztovhr6l5().b[0][1]++, "https://demo.simplersell.com/_address-input"));
var ALLOWED_TYPES = (cov_1ztovhr6l5().s[1]++, [
    "street_address",
    "premise",
    "subpremise",
    "route"
]);
cov_1ztovhr6l5().s[2]++;
var generateGoogleMapsSessionToken = function generateGoogleMapsSessionToken() {
    cov_1ztovhr6l5().f[0]++;
    cov_1ztovhr6l5().s[3]++;
    return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
};
cov_1ztovhr6l5().s[4]++;
var buildAutocompleteUrl = function buildAutocompleteUrl(query, sessionToken) {
    cov_1ztovhr6l5().f[1]++;
    cov_1ztovhr6l5().s[5]++;
    return "".concat(ADDRESS_INPUT_URL, "/autocomplete?sessionToken=").concat(sessionToken, "&query=").concat(query);
};
cov_1ztovhr6l5().s[6]++;
var buildCityAutocompleteUrl = function buildCityAutocompleteUrl(query, sessionToken) {
    cov_1ztovhr6l5().f[2]++;
    cov_1ztovhr6l5().s[7]++;
    return "".concat(ADDRESS_INPUT_URL, "/autocomplete?sessionToken=").concat(sessionToken, "&query=").concat(encodeURIComponent(query), "&types=(regions)");
};
cov_1ztovhr6l5().s[8]++;
var buildPlacesUrl = function buildPlacesUrl(_ref) {
    var source = _ref.source, placeId = _ref.placeId, addressToken = _ref.addressToken, sessionToken = _ref.sessionToken;
    cov_1ztovhr6l5().f[3]++;
    var baseUrl = (cov_1ztovhr6l5().s[9]++, "".concat(ADDRESS_INPUT_URL, "/place"));
    cov_1ztovhr6l5().s[10]++;
    if (source === "casa") {
        cov_1ztovhr6l5().b[1][0]++;
        cov_1ztovhr6l5().s[11]++;
        return baseUrl + "?addressToken=".concat(addressToken);
    } else {
        cov_1ztovhr6l5().b[1][1]++;
    }
    cov_1ztovhr6l5().s[12]++;
    return baseUrl + "?sessionToken=".concat(sessionToken, "&placeId=").concat(placeId);
}; //# sourceMappingURL=googleMaps.mjs.map


/***/ }),

/***/ 86048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Search_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2888);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var SvgSearch = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "#786E64",
            d: "M9.5 16q-2.725 0-4.612-1.888T3 9.5t1.888-4.612Q6.778 3 9.5 3t4.613 1.888T16 9.5a6.1 6.1 0 0 1-1.3 3.8l5.6 5.6a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-5.6-5.6q-.75.6-1.725.95T9.5 16m0-2q1.875 0 3.188-1.312T14 9.5q0-1.876-1.312-3.187Q11.377 5.002 9.5 5T6.313 6.313 5 9.5t1.313 3.188T9.5 14"
        })
    }));
};
var Search_default = SvgSearch;



/***/ })

}]);